import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './SolarEPC.css';
import { useNavigate } from 'react-router-dom';

// Importing images from assets/Project/Project2
import heroImg from '../../assets/Project/Project2/Img1.png';
import image1 from '../../assets/Project/Project2/Image1.png';
import image2 from '../../assets/Project/Project2/Image2.png';
import image3 from '../../assets/Project/Project2/Image3.png';
import image4 from '../../assets/Project/Project2/Image4.png';

// Keep the global references for bottom cards (these were from other projects)
import card1Img from '../../assets/Project/image.png';
import card2Img from '../../assets/Project/image3.png';
import card3Img from '../../assets/Project/image4.png';
import CustomButton from '../Button/CustomButton';

const SolarEPC = () => {
      const navigate = useNavigate();

    return (
        <div className="solar-epc-page">
            {/* Hero Section */}
            <section className="solar-epc-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 hero-text-col">
                            <h1 className="hero-title">Solar EPC Project – 4.2 MW</h1>
                            <h3 className="hero-location">Madhubani, Bihar</h3>
                            <p className="hero-description">
                                This 4.2 MW solar EPC project was developed in Madhubani, Bihar.
                                Our team handled the engineering, procurement, and construction process to ensure smooth and efficient project delivery.
                            </p>
                                       <CustomButton
                variant="white"
                size="lg"
                text=" Discuss Your Project"
                onClick={() => navigate("/contact")}
              />
                        </div>
                        <div className="col-lg-6 hero-image-col">
                            <img src={heroImg} alt="Solar EPC Project Overview" className="hero-img img-fluid" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Main Content Section */}
            <main className="solar-epc-content">
                <div className="container">
                    {/* Project Overview */}
                    <section className="content-section">
                        <h2>PROJECT OVERVIEW</h2>
                        <p>
                            This project was developed to generate clean and stable solar power for the region.
                            From initial design to final commissioning, the goal was clear — build a reliable solar plant that performs well and delivers consistent output.
                            The site was carefully planned, and every stage of construction was monitored to maintain quality and safety standards.
                        </p>
                    </section>

                    {/* Our Role */}
                    <section className="content-section">
                        <h2>OUR ROLE IN THIS PROJECT</h2>
                        <p>In this EPC project, we were responsible for the complete execution process.</p>
                        <p>Our work included:</p>
                        <ul>
                            <li>Detailed engineering and system design</li>
                            <li>Procurement of solar modules and equipment</li>
                            <li>Managing on-site construction activities</li>
                            <li>Supervising installation of structures and panels</li>
                            <li>Ensuring safety compliance at every stage</li>
                        </ul>
                    </section>

                    {/* Project Highlights */}
                    <section className="content-section">
                        <h2>PROJECT HIGHLIGHTS</h2>
                        <ul>
                            <li>4.2 MW solar EPC installation</li>
                            <li>Located in Madhubani, Bihar</li>
                            <li>Complete engineering to commissioning handled</li>
                            <li>Built with focus on quality and durability</li>
                        </ul>
                    </section>

                    {/* Execution Approach */}
                    <section className="content-section">
                        <h2>EXECUTION APPROACH</h2>
                        <ul>
                            <li>Land preparation</li>
                            <li>Structure mounting</li>
                            <li>Solar panel installation</li>
                        </ul>
                    </section>

                    {/* Impact of the Project */}
                    <section className="content-section child-impact">
                        <h2>IMPACT OF THE PROJECT</h2>
                        <ul>
                            <li>This project supports the growing demand for renewable energy in Bihar.</li>
                            <li>It helps reduce dependence on traditional power sources and contributes clean electricity to the grid.</li>
                            <li>The plant stands as a strong example of how proper EPC planning and execution can deliver dependable results.</li>
                        </ul>
                    </section>

                    {/* Image Grid */}
                    <section className="image-grid-section">
                        <div className="row image-grid">
                            <div className="col-md-6 grid-item">
                                <img src={image1} alt="Solar Installation Team" className="img-fluid grid-img" />
                            </div>
                            <div className="col-md-6 grid-item">
                                <img src={image2} alt="Solar Engineers Reviewing" className="img-fluid grid-img" />
                            </div>
                            <div className="col-md-6 grid-item mt-4 mt-md-0 pt-md-4">
                                <img src={image3} alt="Engineer on site" className="img-fluid grid-img" />
                            </div>
                            <div className="col-md-6 grid-item mt-4 mt-md-0 pt-md-4">
                                {/* From the design, there's a 4th image resembling two engineers walking outdoors, I'll reuse one from the project2 folder if there's no 4th explicit image identified, or `669613eab28a267677ccbd6d_Img%203%20(1)%20(1)-p-800.jpg.png` - I'll just use heroImg for the sake of completeness since 4 images are shown in the 2x2 grid */}
                                <img src={image4} alt="Engineers walking" className="img-fluid grid-img" />
                            </div>
                        </div>
                    </section>

                    {/* Explore More Projects */}
                    <section className="explore-more-section">
                        <h2 className="explore-title">Explore More Renewable Energy Projects</h2>
                        <div className="row">
                            {/* Card 1 */}
                            <div className="col-md-4 mb-4">
                                <Link to="/projects/solar-epc" className="text-decoration-none">
                                    <div className="project-card">
                                        <img src={card1Img} alt="Solar EPC" className="card-img-top" />
                                        <div className="card-body">
                                            <h5 className="card-title">Solar EPC,<br />Madhubani, Bihar</h5>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            {/* Card 2 */}
                            <div className="col-md-4 mb-4">
                                <Link to="/projects/solar-hybrid" className="text-decoration-none">
                                    <div className="project-card">
                                        <img src={card2Img} alt="Solar Hybrid EPC" className="card-img-top" />
                                        <div className="card-body">
                                            <h5 className="card-title">Solar Hybrid EPC, Pusa,<br />Samastipur, Bihar</h5>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            {/* Card 3 */}
                            <div className="col-md-4 mb-4">
                                <Link to="/projects/solar-bess" className="text-decoration-none">
                                    <div className="project-card">
                                        <img src={card3Img} alt="Solar + BESS EPC" className="card-img-top" />
                                        <div className="card-body">
                                            <h5 className="card-title">Solar + BESS EPC<br />Tamil Nadu</h5>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </section>
                </div>
            </main>
        </div>
    );
};

export default SolarEPC;
